import { Text } from "@kvix/ui";
import {
  Paper,
  Table as MUITable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow as MUITableRow,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

type TableHeading = {
  id: number;
  heading: string;
};
type TableCell = {
  id: number;
  value: string;
};
type TableRow = {
  id: number;
  Cells: TableCell[];
};
export interface TableData {
  id: number;
  title: string;
  subtitle: string;
  TableHeadings: TableHeading[];
  TableRow: TableRow[];
}
interface TableProps {
  data: TableData;
}

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: (props: any) => (props.noMargin ? 0 : theme.spacing(6)),
    "& h3": {
      marginTop: 40,
      marginBottom: 20,
    },
    "& p": {
      fontStyle: "italic",
      marginBottom: 16,
    },
  },
  container: {
    borderRadius: 6,
  },
}));

export const Table: React.FC<TableProps> = (props) => {
  const classes = useStyles(props);
  const { TableHeadings, TableRow, title, subtitle } = props.data;
  return (
    <div className={classes.root}>
      <Text variant="h3">{title}</Text>
      {subtitle && <Text compact>{subtitle}</Text>}
      <TableContainer component={Paper} className={classes.container}>
        <MUITable>
          <TableHead>
            <MUITableRow>
              {TableHeadings.map(({ heading }, index) => {
                return <TableCell key={index}>{heading}</TableCell>;
              })}
            </MUITableRow>
          </TableHead>
          <TableBody>
            {TableRow.map(({ Cells }, rowIndex) => {
              return (
                <MUITableRow key={rowIndex}>
                  {Cells.map(({ value }, cellIndex) => {
                    return (
                      <TableCell
                        className={
                          rowIndex === TableRow.length - 1 ? "border-none" : ""
                        }
                        key={cellIndex}
                      >
                        {value}
                      </TableCell>
                    );
                  })}
                </MUITableRow>
              );
            })}
          </TableBody>
        </MUITable>
      </TableContainer>
    </div>
  );
};

export default Table;
